/* eslint-disable no-unused-vars */
export enum ESmallFleetOrderStatus {
    PENDING = 'PENDING',
    ASSIGNED = 'ASSIGNED',
    LOST = 'LOST',
}

export enum EReasonForRejection {
    MINIMUM_DRIVER_CASH = 'MINIMUM_DRIVER_CASH',
    MINIMUM_WORK_BALANCE = 'MINIMUM_WORK_BALANCE',
    MINIMUM_BATTERY_PERCENTAGE = 'MINIMUM_BATTERY_PERCENTAGE',
    DRIVER_OFF_DUTY = 'DRIVER_OFF_DUTY',
    DRIVER_BUSY = 'DRIVER_BUSY',
}
